import prod1 from "../Assets/blackcandle.png";
import prod2 from "../Assets/whitecandle.png";
import prod3 from "../Assets/diffuser.png";
import prod4 from "../Assets/diffuser2.png";

export const products = {
"vanilla-reverie": {
  id: 1,
  name: "Vanilla Reverie",
  description: "A warm, creamy vanilla candle with a clean burn and cozy ambiance.",
  fullDescription:
    "Sink into comfort with Vanilla Reverie—a hand-poured candle that blends rich vanilla bean with soft tonka and a hint of caramel over a mellow sandalwood base. Made with a natural soy (coconut-soy) wax blend and a cotton wick for a slow, clean burn that fills your space without overpowering.",
  price: 30,
  volume: "300g",
  tag: "BESTSELLER",
  image: prod1,
  benefits: [
    "Creates a cozy, soothing atmosphere",
    "Comforting vanilla aroma with subtle gourmand notes",
    "Clean, even burn with minimal soot",
    "Hand-poured with quality wax and cotton wick",
    "Perfect for unwinding, gifting, or everyday ambience"
  ],
  ingredients:
    "Natural soy/coconut-soy wax blend, premium phthalate-free fragrance oils (vanilla bean, tonka, caramel, sandalwood), cotton wick (lead- and zinc-free).",
},
  "morning-brew": {
    id: 2,
    name: "Morning Brew",
    description: "A smooth, rich scented candle with a warm, inviting aroma.",
    fullDescription:
      "Morning Brew is a warm, creamy vanilla candle that blends rich vanilla bean with soft tonka and a hint of caramel over a mellow sandalwood base. Made with a natural soy (coconut-soy) wax blend and a cotton wick for a slow, clean burn that fills your space without overpowering.",
    price: 30,
    volume: "300g",
    tag: "NEW FORMULA",
    image: prod2,
    benefits: [
      "Warm, creamy vanilla aroma with subtle gourmand notes",
      "Clean, even burn with minimal soot",
      "Hand-poured with quality wax and cotton wick",
      "Perfect for unwinding, gifting, or everyday ambience"
    ],
    ingredients:
      "Natural soy/coconut-soy wax blend, premium phthalate-free fragrance oils (vanilla bean, tonka, caramel, sandalwood), cotton wick (lead- and zinc-free).",
  },
  "signature-reed-diffuser": {
    id: 3,
    name: "Signature Reed Diffuser",
    description: "Flame-free home fragrance with a clean, modern look.",
    fullDescription:
      "Elevate any room with our Signature Reed Diffuser by BL Aesthetics. Hand-poured with premium, IFRA-compliant fragrance oils, it delivers a consistent, room-filling scent—no flame, no plug-ins. The glossy black cap, jet-black reeds, and our iconic BL label make it as beautiful as it is functional.",
    price: 45,
    volume: "200 ml",
    image: prod3,
    benefits: [
      "Even, continuous fragrance—flame free",
      "Stylish bottle elevates décor",
      "Lasts up to 10–12 weeks",
      "Low-maintenance—refresh by flipping reeds"
    ],
    ingredients:
    "Di-Propylene Glycol (DPG), IFRA-compliant Fragrance Oils, Colorant.",
  },
  "sublime-replenishing-night-masque": {
    id: 4,
    name: "Sublime Replenishing Night Masque",
    description: "Overnight redeemer with Vitamins B",
    fullDescription:
      "Transform your skin overnight with our replenishing night mask. Rich in Vitamin B complex for deep restoration and renewal.",
    price: 100,
    volume: "60 ml",
    image: prod4,
    benefits: [
      "Overnight skin renewal",
      "Deep hydration",
      "Vitamin B complex nourishment",
      "Improves skin texture",
    ],
    ingredients:
      "Water, Niacinamide (Vitamin B3), Panthenol (Vitamin B5), Glycerin, Squalane...",
  },
};

export const getProductBySlug = (slug) => {
  return products[slug];
};

export const getAllProducts = () => {
  return Object.values(products);
};
